import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=76a0ef2c&scoped=true&"
import script from "./Noticia.vue?vue&type=script&lang=js&"
export * from "./Noticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0ef2c",
  null
  
)

export default component.exports